var $ = require('jquery');

function slideUp (element, completed) {
	element = $(element);
	element.velocity('slideUp', 'fast', 'swing', completed);
}
module.exports = slideUp;
